import { Layout } from 'antd';
import React, { useContext } from 'react';
import useUrlState from '../../hooks/useUrlState';
import { Navigate } from 'react-router-dom';
import { AnalysisInProgressContext } from '../ContextWrapper';
import LiveAnalysisReport from '../report/LiveAnalysisReport';
import ArchivedAnalysisReport from '../report/ArchivedAnalysisReport';

const { Content } = Layout;

export default function AnalysisReportPage() {
    const { isAnalysisInProgress, lastAnalysisGuid, lastAnalysisUrl } = useContext(AnalysisInProgressContext);
    const [urlState] = useUrlState();
    const { guid, url } = urlState;

    const hasReportParams = !!guid && !!url;

    const isLiveAnalysis = isAnalysisInProgress || (lastAnalysisGuid === guid && lastAnalysisUrl === url);

    return (
        <Content className="general-layout-content">
            {isLiveAnalysis && <LiveAnalysisReport />}

            {!isLiveAnalysis && hasReportParams && (
                <ArchivedAnalysisReport
                    guid={guid}
                    websiteUrl={url}
                />
            )}

            {isAnalysisInProgress && !hasReportParams && lastAnalysisGuid && (
                <Navigate to={`/analysis/report?guid=${lastAnalysisGuid}&url=${lastAnalysisUrl}`} />
            )}

            {!isAnalysisInProgress && !hasReportParams && <Navigate to="/analysis" />}
        </Content>
    );
}
